{
  "table": {
    "object": "Object",
    "type": "Type",
    "message": "Message",
    "state": "State",
    "actions": "Actions",
    "createdAt": "Created",
    "client": "Client",
    "userFirstName": "User First Name",
    "userLastName": "User Last Name",
    "date": "Date",
    "amount": "Amount",
    "accountType": "Account Type",
    "ticker": "Ticker",
    "currency": "Currency",
    "price": "Price",
    "quantity": "Quantity",
    "organization": "Organization",
    "processDate": "Process Date",
    "objectType": "Object Type",
    "effectiveDate": "Effective Date",
    "settleDate": "Settle Date",
    "custodianAccountNumber": "Custodian Account Number",
    "clientName": "Client Name",
    "transaction": "Transaction",
    "subTransaction": "SubTransaction",
    "cusip": "CUSIP",
    "transactionDesc": "Transaction Description",
    "transactionType": "Transaction Type",
    "commission": "Commission",
    "accruedInterest": "Accrued Interest",
    "securityType": "Security Type",
    "custodian": "Custodian",
    "account": "Account",
    "flags": "Flags",
    "systemUpdated": "System Updated",
    "externalUpdated": "External Updated"
  },
  "state": "State",
  "exportProgressTitleFlags": "Exporting flags",
  "exportProgressTitleActivities": "Exporting activities",
  "transactionType": "Transaction Type",
  "symbol": "Symbol",
  "custodianAccountNumber": "Custodian Account Number",
  "type": "Type",
  "any": "Any",
  "perPage": "Items per page",
  "goTo": "Go to",
  "tabs": {
    "flags": "Flags",
    "activities": "Activities",
    "jobs": "Jobs"
  },
  "flagsMovedModal": {
    "title": "Flags has moved",
    "body": "Flags now lives in its own dashboard with new filters, summaries and a detail view. You will be redirected there now.",
    "confirm": "Go to Flags"
  },
  "activitiesMovedModal": {
    "title": "Activities has moved",
    "body": "Activities now lives in its own dashboard with metrics and a redesigned worklist. You will be redirected there now.",
    "confirm": "Go to Activities"
  },
  "activitiesV3": {
    "pageTitle": "Activities",
    "pageSubtitle": "Monitor custodian activity reconciliation metrics and backlog.",
    "tablePlaceholder": "Activity worklist coming soon",
    "backlogAging": {
      "title": "Backlog Aging",
      "subtitle": "How the pending exception pile is built up by age, day by day.",
      "error": "Unable to load backlog aging chart.",
      "unavailable": "Backlog aging data is unavailable.",
      "empty": "No pending CREATED activities in the backlog.",
      "modes": {
        "today": "Today",
        "trend": "Trend"
      },
      "ranges": {
        "sevenDays": "7d",
        "thirtyDays": "30d"
      },
      "series": {
        "newArrivals": "New arrivals",
        "reconciled": "Reconciled"
      },
      "howToRead": {
        "label": "How to read it:",
        "body": "A healthy backlog is short and flat with little red. A rising stack — especially a thickening red 7+ days cap on the right — means old exceptions are piling up faster than they are cleared, weeks before it becomes a client or compliance issue."
      },
      "bands": {
        "age0_1": "0–1d",
        "age1_3": "1–3d",
        "age3_7": "3–7d",
        "age7Plus": "7d+"
      },
      "bandsLong": {
        "age0_1": "0–1 day",
        "age1_3": "1–3 days",
        "age3_7": "3–7 days",
        "age7Plus": "7+ days"
      },
      "today": {
        "subtitle": "The current pending pile, split by how long items have been waiting.",
        "pendingLabel": "Pending today:",
        "items_one": "{{count}} item",
        "items_other": "{{count}} items",
        "overSla": "{{count}} over SLA",
        "slaTarget": "SLA target: 0 items beyond {{days}} days",
        "slaChip": "SLA",
        "table": {
          "ageBand": "Age band",
          "count": "Count",
          "share": "Share",
          "totalPending": "Total pending"
        }
      }
    },
    "metrics": {
      "error": "Unable to load activity metrics.",
      "occurringToday": {
        "title": "Occurring Today",
        "hint": "Activities occurring today (UTC)"
      },
      "created": {
        "title": "Created",
        "hint": "Pending backlog (all time)"
      },
      "reconciledToday": {
        "title": "Reconciled Today",
        "hint": "Reconciled today (UTC)"
      },
      "agingPending": {
        "title": "Aging Pending",
        "hint": "Pending 3+ days (UTC)"
      }
    },
    "filters": {
      "state": "State",
      "stateCreated": "Created",
      "stateReconciledToday": "Reconciled (today)",
      "type": "Type",
      "aging": "Aging",
      "any": "Any",
      "agingOneDay": "1+ days",
      "agingThreeDays": "3+ days",
      "agingSevenDays": "7+ days",
      "search": "Search",
      "searchPlaceholder": "Client, account #, or ticker",
      "clearFilters": "Clear filters",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all"
    },
    "table": {
      "client": "Client",
      "organization": "Organization",
      "date": "Date",
      "type": "Type",
      "custodianAcct": "Custodian acct",
      "amount": "Amount",
      "acctType": "Acct type",
      "ticker": "Ticker",
      "state": "State",
      "aging": "Aging",
      "reconciledVia": "Reconciled via",
      "empty": "No activities match the current filters."
    },
    "detail": {
      "tabs": {
        "details": "Details",
        "account": "Account",
        "flags": "Flags",
        "notes": "Notes",
        "raw": "Raw JSON"
      },
      "sections": {
        "general": "General",
        "transaction": "Transaction",
        "securityTrade": "Security & Trade"
      },
      "fields": {
        "processDate": "Process date",
        "effectiveDate": "Effective date",
        "settleDate": "Settle date",
        "accountType": "Account type",
        "custodianAccountNumber": "Custodian account number",
        "isCancel": "Cancel",
        "transactionDesc": "Description",
        "transactionId": "Transaction ID",
        "subTransactionId": "Sub-transaction ID",
        "symbol": "Symbol",
        "cusip": "CUSIP",
        "securityType": "Security type",
        "quantity": "Quantity",
        "priceCents": "Price",
        "commission": "Commission",
        "accruedInterest": "Accrued interest",
        "bookValueAmountCents": "Book value"
      },
      "yes": "Yes",
      "no": "No",
      "amountSummary": "Amount",
      "flags": {
        "empty": "No flags linked to this activity.",
        "error": "Unable to load flags for this activity.",
        "summary": "{{total}} flags · {{active}} active",
        "capped": "showing {{cap}} of {{total}}",
        "incomplete": "Some activity flags could not be loaded.",
        "openInFlagRecon": "Open flags",
        "columns": {
          "type": "Type",
          "category": "Category",
          "priority": "Priority",
          "state": "State",
          "firstSeen": "First seen",
          "notes": "Notes"
        }
      },
      "account": {
        "empty": "No reconciliation snapshot available for this account.",
        "dayEmpty": "No reconciliation snapshot for this date.",
        "error": "Unable to load the account snapshot.",
        "openInRecon": "Open in Account Reconciliation →",
        "banner": {
          "tiesOut": "Account ties out",
          "doesNotTieOut": "Account does not tie out",
          "awaitingCustodian": "Not yet comparable — awaiting custodian data",
          "awaitingSystem": "Not yet comparable — awaiting system data",
          "awaitingBoth": "Not yet comparable — awaiting system and custodian data",
          "asOf": "As of {{date}}"
        },
        "asOf": {
          "title": "Snapshot — as of",
          "prev": "Previous snapshot day",
          "next": "Next snapshot day",
          "diverged": "Viewing a past snapshot ·",
          "reset": "Reset to latest"
        },
        "diff": {
          "security": "Security",
          "systemQty": "System qty",
          "custodianQty": "Cust. qty",
          "deltaQty": "Δ qty",
          "systemValue": "System value",
          "custodianValue": "Cust. value",
          "deltaValue": "Δ value",
          "pending": "pending",
          "cash": "Cash",
          "empty": "No holdings on the selected snapshot."
        },
        "narrative": {
          "tiesOut": "Account ties out on the latest snapshot — this {{type}} is already reflected.",
          "securityGap": "Reconciling this {{type}} may close part of the {{ticker}} quantity gap.",
          "cashPending": "The cash gap for this {{type}} includes in-flight amounts pending on our side.",
          "cashGap": "Reconciling this {{type}} should clear the cash gap on the latest snapshot.",
          "genericBreak": "This {{type}} may relate to the account break on the latest snapshot."
        }
      },
      "notes": {
        "composePlaceholder": "Add notes about your investigation…",
        "save": "Save",
        "saved": "Notes saved",
        "saveError": "Could not save notes",
        "historyEmptyTitle": "No notes yet",
        "historyEmptyReadOnlyTitle": "No notes for this activity",
        "historyEmptyDescription": "Add a note to capture important context about this activity.",
        "cleared": "Cleared"
      },
      "raw": {
        "copy": "Copy JSON"
      },
      "footer": {
        "retry": "Retry",
        "retryFailed": "Retry failed. Try again.",
        "dismiss": "Dismiss",
        "moreActions": "More actions",
        "readOnly": "This activity is already reconciled ({{method}})."
      },
      "dismissModal": {
        "title": "Dismiss activity?",
        "body": "Dismiss marks this activity as reconciled without linking an internal transaction. This cannot be undone from this screen.",
        "confirm": "Dismiss",
        "cancel": "Cancel"
      }
    },
    "bulk": {
      "selectedCount": "{{count}} selected",
      "selectAllOnPage": "Select all on page",
      "clearSelection": "Clear selection",
      "retry": "Bulk Retry"
    }
  },
  "flagState": {
    "FLAGGED": "Active",
    "FIXED": "Done",
    "TRIVIAL": "Trivial",
    "ALL_FIXED": "Mark selected as Done",
    "ALL_RECONCILE": "Reconcile all",
    "ALL_FORCE_RECONCILE": "Force Reconcile all"
  },
  "activityState": {
    "CREATED": "Created",
    "RECONCILED": "Reconciled",
    "RECONCILE": "Reconcile",
    "FORCE_RECONCILE": "Force Reconcile"
  },
  "jobEventType": {
    "RECONCILIATION": "RECONCILIATION"
  },
  "jobState": {
    "ANY": "ANY",
    "INITIATED": "INITIATED",
    "COMPLETED": "COMPLETED",
    "FAILED": "FAILED"
  },
  "eventTable": {
    "eventType": "Event Type",
    "jobName": "Job Name",
    "ranAt": "Ran At",
    "updatedAt": "Updated",
    "state": "State",
    "organization": "Organization",
    "action": "Action"
  },
  "jobDetails": {
    "title": "Additional details for {{jobName}} ran on {{ranAt}}"
  },
  "runReconciliation": {
    "title": "Run Reconciliation",
    "reconcileActivities": "Recon Activities",
    "updateCashAndHoldings": "Update Cash and Holdings",
    "reconCashAndHoldings": "Recon Cash and Holdings",
    "publishSnapshots": "Publish Snapshots",
    "runReconcileToastMessage": "Reconcile requested"
  },
  "reconFlags": {
    "title": "Reconciliation",
    "summaryTitle": "Summary dashboard",
    "spotlight": {
      "negativeCash": {
        "title": "Negative Cash"
      },
      "negativeHolding": {
        "title": "Negative Holding"
      },
      "holdingsMismatch": {
        "title": "Holdings Mismatch"
      },
      "moneyAvailableMismatch": {
        "title": "Money Avail. Mismatch"
      }
    },
    "totalFlags": "Total flags",
    "totalFlagsHint": "Active in organization",
    "unresolvedThreePlus": "Unresolved for 3+ days",
    "unresolvedThreePlusHint": "Active, first seen more than 3 days ago",
    "severity": {
      "all": "All",
      "critical": "Critical",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "severityLabel": {
      "CRITICAL": "Critical",
      "HIGH": "High",
      "MEDIUM": "Medium",
      "LOW": "Low",
      "UNKNOWN": "Unknown"
    },
    "filters": {
      "flagType": "Flag Type",
      "category": "Category",
      "priority": "Priority",
      "aging": "Aging",
      "clearFilters": "Clear filters",
      "any": "Any",
      "agingOneDay": "1+ days",
      "agingThreeDays": "3+ days",
      "agingSevenDays": "7+ days"
    },
    "categories": {
      "snapshot": "Snapshot",
      "warning": "Warning",
      "cashHoldings": "Cash & Holdings",
      "activity": "Activity",
      "transfer": "Transfer",
      "account": "Account",
      "product": "Product"
    },
    "flagTypes": {
      "NEGATIVE_CASH": "Negative cash",
      "NEGATIVE_HOLDING": "Negative holding",
      "DIFFERENT_HOLDINGS_V2": "Holdings mismatch",
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": "Money avail. mismatch"
    },
    "flagState": {
      "FLAGGED": "Active",
      "FIXED": "Resolved",
      "TRIVIAL": "Dismissed"
    },
    "searchPlaceholder": "Search by client name",
    "searchHelp": "Select a client to show flags for their accounts (up to {{max}} account IDs).",
    "searchHelpAria": "About client search",
    "searchError": "Client search failed. Please try again.",
    "selection": {
      "count": "{{count}} exceptions selected",
      "selectAllOnPage": "Select all on this page",
      "clear": "Clear Selection",
      "dismiss": "Dismiss",
      "dismissConfirmTitle": "Dismiss selected flags?",
      "dismissConfirmBody": "This will mark the selected flag(s) as dismissed. This operation cannot be undone.",
      "dismissConfirmAction": "Dismiss",
      "resolve": "Resolve",
      "resolveConfirmTitle": "Resolve selected flags?",
      "resolveConfirmBody": "This will mark the selected flag(s) as Resolved and remove them from the Active list. This cannot be undone from this screen.",
      "resolveConfirmAction": "Resolve"
    },
    "table": {
      "account": "Account",
      "firstSeen": "First seen"
    },
    "agingDays_one": "{{count}} day",
    "agingDays_other": "{{count}} days",
    "agingHelp": "Days since this issue was <bold>first observed</bold> (First Seen). The flag may refresh daily when reconciliation re-emits the same issue; that does <bold>not</bold> reset aging. Resolve or dismiss when fixed.",
    "agingHelpAria": "About the aging column",
    "drawer": {
      "close": "Close",
      "title": "Flag detail",
      "fallbackTitle": "Flag details",
      "detailsHeading": "Details",
      "summary": {
        "type": "Type:",
        "account": "Account:",
        "date": "Date:",
        "firstSeen": "First seen:"
      },
      "followUpTask": "Create follow-up task",
      "resolve": "Resolve",
      "resolveSuccess": "Flag resolved",
      "resolveError": "Could not resolve this flag",
      "dismissSuccess": "Flag dismissed",
      "dismissError": "Could not dismiss this flag",
      "tabs": {
        "overview": "Overview",
        "notes": "Notes",
        "rawJson": "Raw JSON"
      },
      "sections": {
        "issueSummary": "Issue summary",
        "flagSummary": "Flag summary",
        "account": "Account",
        "activity": "Activity & custodian transfer",
        "systemIdentifiers": "System identifiers",
        "additional": "Additional details"
      },
      "fields": {
        "flagType": "Flag Type",
        "objectType": "Object Type",
        "priority": "Priority",
        "created": "Created",
        "firstSeen": "First seen",
        "state": "State",
        "custodianAcctShort": "Custodian Acct #",
        "accountStatus": "Account Status",
        "transactionId": "Transaction ID",
        "subTransactionId": "Sub-Trans ID",
        "financialProductId": "Fin Product ID",
        "activityType": "Type",
        "activityStatus": "Status"
      },
      "internalNotesHeading": "Internal notes",
      "notesLabel": "Notes",
      "notesPlaceholder": "Add notes about your investigation…",
      "notesHistoryEmptyTitle": "No notes yet",
      "notesHistoryEmptyReadOnlyTitle": "No notes for this flag",
      "notesHistoryEmptyDescription": "Add a note to capture important context about this flag.",
      "addNote": "Add note",
      "notesSaved": "Notes saved",
      "notesSaveError": "Could not save notes",
      "discardDraftConfirmTitle": "Discard unsaved note?",
      "discardDraftConfirmBody": "You have a note that has not been saved. Close without saving?",
      "discardDraftConfirmAction": "Discard and close"
    },
    "bulkDismissError": "Could not dismiss selected flags",
    "bulkDismissSuccess": "{{count}} flags dismissed",
    "bulkDismissPartial": "{{failed}} of {{total}} flags could not be dismissed",
    "bulkDismissNoFlaggedSelected": "None of the selected flags can be dismissed. Only active flags can be dismissed from this view.",
    "bulkResolveError": "Could not resolve selected flags",
    "bulkResolveSuccess": "{{count}} flags resolved",
    "bulkResolvePartial": "{{failed}} of {{total}} flags could not be resolved",
    "bulkResolveNoFlaggedSelected": "None of the selected flags can be resolved. Only active flags can be resolved from this view.",
    "emptyTable": "No flags match the current filters.",
    "emptyTableHint": "Try adjusting your filters or search.",
    "emptyTableNoResults": "No flags found.",
    "emptyTableNoData": "No data available.",
    "pagination": {
      "summary": "Showing {{start}}–{{end}} of {{total}} flags"
    }
  },
  "flagGlossary": {
    "title": "Flag Glossary",
    "openGlossary": "Glossary",
    "backToFlags": "Back to flags",
    "searchPlaceholder": "Search flags",
    "loadError": "Could not load flag glossary. Please try again.",
    "emptyTable": "No flags match the current filters.",
    "emptyTableHint": "Try adjusting your filters or search.",
    "emptyTableNoResults": "No flags found.",
    "emptyTableNoData": "No flag glossary data available.",
    "emptyTableError": "Couldn't load flags.",
    "emptyTableErrorHint": "Something went wrong. Please try again.",
    "filters": {
      "category": "Category",
      "clearFilters": "Clear filters"
    },
    "kpi": {
      "total": "Total flags available",
      "totalHint": "All flag types in the glossary",
      "thresholded": "Thresholded flags",
      "thresholdedHint": "Flags that support amount or percent thresholds",
      "turnedOff": "Turned off",
      "turnedOffHint": "Flag types disabled for this organization"
    },
    "table": {
      "flagName": "Flag name",
      "description": "Description",
      "exampleTrigger": "Example trigger",
      "category": "Category",
      "actualPriority": "Actual priority",
      "actualThreshold": "Actual threshold",
      "defaultPriority": "Default priority",
      "defaultThreshold": "Default threshold"
    },
    "pagination": {
      "summary": "Showing {{start}}–{{end}} of {{total}} flag types"
    },
    "entries": {
      "INVALID_BOOK_VALUE_AMOUNT": {
        "description": "A switch activity in the custodian's data has a valid quantity, price, and symbol, but the book value amount doesn't make sense for the transaction type (a switch-in should have a positive book value; a switch-out should have a negative one).",
        "exampleTrigger": "Switch-in for ABC has qty 10 and a price, but the book value is 0, null or missing from the custodian data"
      },
      "FEE_NOT_FOUND": {
        "description": "A fee activity appears in the custodian feed, but no matching fee withdrawal transfer was found on the platform",
        "exampleTrigger": "A $25 management fee appears in the custodian data, but no corresponding fee transfer exists on the platform to reconcile against it."
      },
      "FEE_AMOUNT_DIFFERENT": {
        "description": "Custodian fee activity does not match with platform fee activity",
        "exampleTrigger": "Custodian fee is $125.00 and platform fee withdrawals sum to $100.00"
      },
      "TRADE_NOT_FOUND": {
        "description": "Custodial data has a trade record, but the platform does not have a corresponding trade entry.",
        "exampleTrigger": "Custodian activity shows a BUY of XYZ on account 123, but the platform does not have a corresponding trade to match it."
      },
      "ACCOUNT_NOT_FOUND": {
        "description": "An activity or record in the custodian's data references an account number that doesn't exist on the platform where it's expected to be found.",
        "exampleTrigger": "Custodian sends trade data for account 12345678, account 12345678 does not exist within the platform"
      },
      "TRANSFER_NOT_FOUND": {
        "description": "A transfer-related activity appears in the custodian's data (or an incoming settlement has no in-progress candidates), but no matching transfer was found on the platform.",
        "exampleTrigger": "Custodian posts an incoming settlement of $10,000 and the account/sub-account on the platform has no REQUESTED/PROCESSING external transfer transaction"
      },
      "UNKNOWN_ACTIVITY_TYPE": {
        "description": "An activity code or type reported by the custodian or the platform does not match any recognized activity type in the mapping configuration.",
        "exampleTrigger": "The custodian's data includes an activity code with no corresponding mapping to a known activity type on the platform."
      },
      "FINANCIAL_PRODUCT_NOT_FOUND": {
        "description": "An activity or holding references a financial product (security, fund, etc.) that isn't in the platform's product catalog.",
        "exampleTrigger": "A trade references security CUSIP 123456789, but no matching financial product record exists in the platform's catalog."
      },
      "NOT_CORPORATE_ACCOUNT": {
        "description": "An activity type that's only expected on corporate accounts was posted to a non-corporate account instead.",
        "exampleTrigger": "A corporate activity is posted to an individual taxable account instead of a corporate account."
      },
      "TOO_MANY_EXTERNAL_TRANSFER_IN_CANDIDATES_FOUND": {
        "description": "More than one custodian transfer matches the details of a single expected incoming transfer, so the platform can't automatically determine which one applies.",
        "exampleTrigger": "Three separate custodian transfers match the same deposit reference and amount, so the platform can't automatically determine which one applies."
      },
      "CURRENCY_IS_NOT_AVAILABLE": {
        "description": "An activity references a currency that is not enabled or supported for the account at the custodian.",
        "exampleTrigger": "A trade for account 12345678 is denominated in Euros, but that currency hasn't been enabled for the account's connection with the custodian."
      },
      "NSF_REBOOKING_DETECTED": {
        "description": "An NSF activity is skipped because it matches a custodian rebooking pattern: a paired reversal and deposit of the same amount post to the account on the same day (often used when the custodian corrects contributor codes).",
        "exampleTrigger": "A −$500 NSF and a +$500 deposit post to the same account on the same day, so the NSF is skipped and this flag is raised instead."
      },
      "HBP_WITHDRAW_TRANSFER_NOT_FOUND": {
        "description": "An HBP withdrawal activity appears in the custodian's data, but no matching Home Buyers' Plan withdraw was found on the platform for that account.",
        "exampleTrigger": "Custodian data shows an HBP withdrawal of $35,000 on an RRSP account, but the platform has no matching Home Buyers' Plan withdraw to reconcile against it."
      },
      "EFT_ACTIVITY_NOT_FOUND": {
        "description": "An NSF activity references a prior transaction that has no matching EFT or internal withdrawal activity in the custodian's data for that account and currency.",
        "exampleTrigger": "An NSF of −$1,200 is received, but no matching EFT or internal withdrawal activity exists for that account and currency."
      },
      "TRANSFER_AMOUNT_DIFFERENT": {
        "description": "An incoming custodian settlement amount differs by more than a fixed 10% tolerance from every in-progress external transfer candidate on the sub-account. Within that tolerance the platform auto-reconciles to the custodian's amount without raising a flag; outside it, automatic matching is blocked.",
        "exampleTrigger": "A $10,000 settlement is received, but the only in-progress candidate is $8,500 — a 15% gap, outside the fixed 10% tolerance — so the platform can't automatically match it and flags it for manual reconciliation."
      },
      "TRANSFER_IMPORT_FAILED": {
        "description": "A transfer record from the custodian's import file was marked as failed and was not successfully imported to the platform.",
        "exampleTrigger": "A transfer record in the custodian's import file is marked as failed, so it isn't imported to the platform."
      },
      "TRANSFER_STUCK_PROCESSING": {
        "description": "A user-initiated transfer has stayed in Processing status longer than the 2 business day SLA.",
        "exampleTrigger": "A withdrawal moved to Processing status on Monday and is still there on Wednesday, past the 2 business day SLA."
      },
      "TRANSFER_STUCK_INITIATED": {
        "description": "A user-initiated withdrawal has stayed in Initiated status for 3 business days without moving forward.",
        "exampleTrigger": "A withdrawal entered Initiated status 3 business days ago and is still sitting there without progressing."
      },
      "TRANSFER_STUCK_READY": {
        "description": "A user-initiated transfer has stayed in Ready status longer than the 3 business day SLA, or the custodian's submission failed in a way that raises this same flag.",
        "exampleTrigger": "A deposit has been sitting in Ready status for more than 3 business days without progressing."
      },
      "SCHEDULED_TRANSFER_SKIPPED": {
        "description": "A recurring or one-time scheduled transfer did not create a transfer on its run date. The schedule still moves to its next date (a one-time schedule is canceled), so the missed cycle is not retried.",
        "exampleTrigger": "A monthly deposit was refused because the client's annual information update is overdue, or its sub-account is no longer active."
      },
      "SCHEDULED_INCOME_FUND_TRANSFER_SKIPPED": {
        "description": "A scheduled RIF/LIF income payment could not create its withdrawal. The schedule keeps its current date and is not picked up again, so payments stop until the schedule is fixed.",
        "exampleTrigger": "A monthly RIF payment was refused because the client's annual information update is overdue."
      },
      "FAILED_ACCOUNT": {
        "description": "Account setup or provisioning failed partway through the process, so it needs operational follow-up to resolve.",
        "exampleTrigger": "Account creation completes on the platform, but the custodian's onboarding step comes back with a failure status."
      },
      "FAILED_CUSTODIAN_OPENING": {
        "description": "Custodian account opening (or, in some paths, transfer submission) comes back with a pending task list instead of confirming the account was opened.",
        "exampleTrigger": "Custodian account opening returns a pending task list instead of a completed status, so the flag is raised."
      },
      "FAILED_CUSTODIAN_ACCOUNT_OPENING": {
        "description": "Submitting the custodian account opening request failed (exception / unsuccessful open), so no confirmed custodian account was established.",
        "exampleTrigger": "The custodian's account-opening request fails with a connection timeout, so no confirmed account was established and the flag is raised."
      },
      "ACCOUNT_CLOSED": {
        "description": "Custodial data is stating the account in question is CLOSED, while the platform shows it as ACTIVE",
        "exampleTrigger": "Account 12345678 is marked as CLOSED based off of custodial data, the platform still shows account 12345678 as ACTIVE"
      },
      "TOTAL_MARKET_VALUE_INCORRECT": {
        "description": "An account's market value on the platform has dropped more than the configured threshold (15% by default) compared to the previous day's reconciliation snapshot; increases don't trigger this flag. Organizations can set their own threshold (5% minimum) or turn the flag off entirely for a custodian connection.",
        "exampleTrigger": "The platform's market value was $100,000 the day before and $80,000 today — a 20% drop — which exceeds the org's threshold (15% by default), so the flag is raised."
      },
      "STATEMENT_NOT_FOUND": {
        "description": "No account statement was found for the prior month, even though the account still shows market value on the platform.",
        "exampleTrigger": "Account 98765432 has $12,500 market value but no statement for June 2026"
      },
      "CASH_NOT_FOUND": {
        "description": "Discrepancy between custodial data and the platform's data regarding cash.",
        "exampleTrigger": "Custodian is reporting a cash balance for account 12345678, the platform does not have a cash record for the account"
      },
      "HOLDING_NOT_FOUND": {
        "description": "The custodian reports a holding for an account that has no matching position in the platform's records.",
        "exampleTrigger": "The custodian reports 200 shares of symbol XYZ for an account, but the platform shows no position in that symbol."
      },
      "HOLDING_NOT_FOUND_IN_CUSTODIAN": {
        "description": "A holding exists in the platform's records for an account, but the custodian's holdings don't include a matching position.",
        "exampleTrigger": "The platform shows 100 shares of symbol ABC for an account, but the custodian's holdings don't list that symbol."
      },
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": {
        "description": "After cash reconciliation, the money available in the custodial data and on the platform do not match.",
        "exampleTrigger": "Custodial data shows money available of $100.00 and the platform shows $95.00"
      },
      "DIFFERENT_HOLDINGS_V2": {
        "description": "When reconciling holdings between the custodian and platform, the quantity differs for a given asset.",
        "exampleTrigger": "Custodial data shows 100 shares of XYZ, while the platform shows 90 shares"
      },
      "NEGATIVE_CASH": {
        "description": "An account's cash balance on the platform has dropped below zero, based on the platform's own records rather than a comparison to custodian data.",
        "exampleTrigger": "An account's cash balance on the platform goes negative after a trade settles, based on the platform's own records only."
      },
      "NEGATIVE_HOLDING": {
        "description": "A security position's share or unit quantity on the platform is recorded as a negative number, based on the platform's own holdings records rather than a comparison to custodian data.",
        "exampleTrigger": "A holding's quantity for a symbol on the platform is recorded as less than zero, based on the platform's own records only."
      },
      "PENDING_TRANSACTION_MONEY_AVAILABLE_VALUE_INCORRECT": {
        "description": "Same as Money Available Value Incorrect V2, but the comparison uses money available adjusted for pending transactions.",
        "exampleTrigger": "After adjusting for pending trades, the platform shows $5,000 available, but the custodian's snapshot implies $5,200."
      },
      "PENDING_TRANSACTION_DIFFERENT_HOLDINGS": {
        "description": "Same as Different Holdings V2, but the platform's quantity is adjusted for pending transactions before it's compared to the custodian's.",
        "exampleTrigger": "After pending sells, the platform projects 50 shares of symbol ABC, but the custodian's data still shows 60 shares."
      },
      "DIFFERENT_BOOKVALUE": {
        "description": "Book value between the custodian and platform does not match.",
        "exampleTrigger": "Custodial data shows a book value of $1,000 and platform book value is $1,050 for a particular asset"
      },
      "NO_SNAPSHOTS_RECEIVED": {
        "description": "The platform didn't generate a daily snapshot for a sub-account on the expected date. This is a proxy for the custodian's data not arriving or processing in time — it checks the platform's own snapshot output, not the custodian file itself.",
        "exampleTrigger": "A sub-account has no daily snapshot for the expected date, even though one is expected — often because the custodian's data didn't arrive or process in time."
      },
      "SNAPSHOT_MISSING": {
        "description": "A sub-account had a daily snapshot the day before, but no snapshot was recorded for it today.",
        "exampleTrigger": "A sub-account had daily snapshot data yesterday, but none was recorded for it today."
      },
      "SNAPSHOT_ANOMALY": {
        "description": "A daily snapshot's contribution figures don't add up: on an account's first snapshot, market value, net contribution, and new contribution don't match each other; on later snapshots, the recorded new contribution doesn't match the actual day-over-day change in net contribution.",
        "exampleTrigger": "Yesterday's net contribution was $1,000 and today's is $1,100 (a $100 change), but the day's recorded new contribution is only $50."
      },
      "SNAPSHOT_PRICE_NOT_FOUND": {
        "description": "A snapshot needs a market price to value a position, but no price could be found for that date.",
        "exampleTrigger": "A snapshot includes a position in symbol XYZ, but no market price is available to value it for that date."
      },
      "NOT_ENOUGH_MONEY_AVAILABLE_IN_ACCOUNT": {
        "description": "A withdraw-all cannot be processed because the money available across the account, after summing any negative available balances, is insufficient.",
        "exampleTrigger": "A withdraw-all is attempted on an account for $5,000, but the account (including its sub-accounts) has a money available of only $4,500."
      },
      "RISKY_DIFFERENT_HOLDING_MF_SELL_ALL": {
        "description": "For a mutual-fund sell-all trade, the quantity the platform expects and the quantity the custodian reports differ by at least 10%.",
        "exampleTrigger": "Sell-all expects quantity 100 but activity quantity is 85 (15% discrepancy)"
      },
      "RISKY_DIFFERENT_HOLDING_USD_ETF": {
        "description": "For a USD ETF trade, the value the platform expects and the value the custodian reports (quantity × price) differ by at least 10%.",
        "exampleTrigger": "Trade allocated $10,000 but fill value is $8,500 (15% value discrepancy)"
      }
    }
  },
  "accountSnapshot": {
    "security": "Security",
    "systemQuantity": "System Quantity",
    "externalQuantity": "External Quantity",
    "diffQuantity": "Diff Quantity",
    "systemPrice": "System Price",
    "externalPrice": "External Price",
    "diffPrice": "Diff Price",
    "systemValue": "System Value",
    "externalValue": "External Value",
    "diffValue": "Diff Value",
    "systemBookValue": "System Book Value",
    "externalBookValue": "External Book Value",
    "diffBookValue": "Diff Book Value",
    "ledger": "Ledger",
    "transfers": "Transfers",
    "tradeOrders": "Trade Orders",
    "custodianActivities": "External Activities",
    "total": "Total"
  },
  "accountsBoard": {
    "status": {
      "flagged": "Flagged",
      "tiedOut": "Tied out",
      "awaitingData": "Awaiting data",
      "awaitingTooltip": {
        "custodian": "Awaiting custodian data — not compared yet",
        "oneVest": "Awaiting OneVest data — not compared yet",
        "both": "Awaiting both sides' data — not compared yet"
      }
    },
    "chip": {
      "CASH": "CASH",
      "QTY": "QTY",
      "EOD": "EOD",
      "BOOK": "BOOK",
      "PENDING": "PENDING"
    },
    "breakValue": {
      "zeroTooltip": "No market-value break; the difference is book-value / EOD-price only, or explained by pending activity"
    },
    "tieOut": {
      "verdict": {
        "flagged": "Does not tie out",
        "tiedOut": "Ties out",
        "awaitingData": "Not yet comparable"
      },
      "counts": {
        "critical_one": "{{count}} critical break",
        "critical_other": "{{count}} critical breaks",
        "pending_one": "{{count}} pending difference",
        "pending_other": "{{count}} pending differences",
        "criticalAndPending_one": "{{count}} critical break · $t(reconciliation:accountsBoard.tieOut.counts.pending, {\"count\": {{pendingCount}} })",
        "criticalAndPending_other": "{{count}} critical breaks · $t(reconciliation:accountsBoard.tieOut.counts.pending, {\"count\": {{pendingCount}} })",
        "pendingOnly": "difference explained by pending activity",
        "minorOnly": "non-critical difference only",
        "minorAndPending": "non-critical and pending differences",
        "none": "no differences",
        "awaiting": {
          "custodian": "awaiting custodian data",
          "oneVest": "awaiting OneVest data",
          "both": "awaiting both sides' data"
        }
      },
      "net": {
        "netBreak": "Net break",
        "netAfterPending": "Net (after pending)",
        "net": "Net"
      }
    },
    "banner": {
      "awaiting": {
        "custodian": "Not yet comparable — awaiting custodian data",
        "oneVest": "Not yet comparable — awaiting OneVest data",
        "both": "Not yet comparable — awaiting both sides' data"
      },
      "stepBack": "‹ step back to the last compared day",
      "flagged": "Account does not tie out",
      "flaggedSingle_one": "Net break {{net}} · {{count}} critical break",
      "flaggedSingle_other": "Net break {{net}} · {{count}} critical breaks",
      "flaggedSingleWithPending_one": "Net break {{net}} · {{count}} critical break · $t(reconciliation:accountsBoard.tieOut.counts.pending, {\"count\": {{pendingCount}} })",
      "flaggedSingleWithPending_other": "Net break {{net}} · {{count}} critical breaks · $t(reconciliation:accountsBoard.tieOut.counts.pending, {\"count\": {{pendingCount}} })",
      "flaggedMixed": "Break magnitude {{breakValue}} (mixed currencies, approximate, no FX conversion)",
      "pendingTiesOut": "Balances tie out — difference explained by pending activity",
      "pending": "Pending {{pending}}",
      "minorTiesOut": "Balances tie out — non-critical difference only",
      "bookDiff": "Book-value diff {{amount}}",
      "eodNet": "Net {{net}} (EOD price)",
      "tiesOut": "Account ties out",
      "clean": "Net $0.00 · no breaks",
      "noSnapshot": "No snapshot for this account on {{date}}."
    },
    "freshness": {
      "custodianAfter": "Both sides present · custodian {{lag}} after OneVest",
      "oneVestAfter": "Both sides present · OneVest {{lag}} after custodian",
      "awaiting": {
        "custodian": "Awaiting custodian data",
        "oneVest": "Awaiting OneVest data",
        "both": "Awaiting both sides' data"
      }
    },
    "flagRow": {
      "cash": "Cash",
      "bookOnly": "book only",
      "pendingSubLine": "pending {{pending}} · not a break",
      "net": "net {{net}}"
    },
    "search": {
      "selectedClient_one": "Selected client · {{count}} account",
      "selectedClient_other": "Selected client · {{count}} accounts"
    }
  }
}
